import { Fragment, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useFetch from "../hook/useFetch";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/user-slice";
import Header from "./Header";
import Sidebar from './Sidebar';
import { notificationActions } from "../store/notification-slice";
import Backdrop from './Backdrop';
import useAuthorized from "../hook/useAuthorized";
import Skeleton from "react-loading-skeleton";

export default function DefaultLayout() {

    let token = useSelector(state => state.user.token)
    let dispatch = useDispatch()
    const { get } = useFetch()
    let navigate = useNavigate()
    let user = useSelector(state => state.user.user)
    let notification = useSelector(state => state.notification.notification)

    const { authorized } = useAuthorized()

    const [loadComponenets,setLoadComponenets]=useState(false)

    useEffect(() => {

        if(!token){
            navigate('/login')
        }

        if (token) {
            if (!user) {
                get('/user', {
                    token
                }, () => {
                    dispatch(userActions.setUser(null))
                    dispatch(userActions.setToken(null))
                    navigate('/login')
                }, (data) => {
                    dispatch(userActions.setUser(data))
                })
            }
        }

        if (notification) {
            setTimeout(() => {
                dispatch(notificationActions.setNotification(null))
            }, 3000)
        }

        if(authorized!==null){
            dispatch(userActions.setIsAdmin(authorized))
            setLoadComponenets(true)
        }

    }, [notification,authorized])


    if(!loadComponenets){
        return <Skeleton count={50} />
    }

    

    return <div className="bg-maryam" style={{ display: 'flex', overflow: 'auto',minHeight:'100vh' }} >

        <Sidebar  />
        <div className="content" style={{ display: 'flex', flexDirection: 'column',width:'100%' }} >
            <Header  />
            <main className="default-layout" style={{ padding: 10 }} >
                <Outlet />
            </main>
        </div>

        {notification &&
            <div className={`notification alert ${notification.status ? 'bg-success' : 'bg-warning'}`} style={{position:'fixed',bottom:0,right:0}} > {notification.message} </div>
        }

        <Backdrop />
    </div>

}